import * as ApiEvents from './apiEvents'
import { showToast } from '../../commonComponents/showToast'
import store from '../store'
import { HttpClient } from '../../../commonApis/httpClient'
export const saveEvent = (eventMessage) => ({
  eventType: ApiEvents.SAVE_FORM_EU,
  eventTime: Date.now(),
  eventMessage,
})
export const saveEventCDS = (eventMessage) => ({
  eventType: "SAVE_ITEM_CDS",
  eventId: Date.now(),
  eventMessage,
})
export const containerPayload = (payload)=>{
  let dataSent = saveEventCDS({
    shipmentId:  window.shipmentId ,
    invoice:{
      ...payload
    }
    
    // intentExport: { value: intentExportValue },
 
  })
  return HttpClient.post(dataSent)
  .then((resp) => resp)
  .catch((error) => {
    console.error(`Error in delete deleteMerchandiseInfo : `, error)
  })

}
export const createInvoiceItems = (intentExportValue) => {
  let dataSent = saveEvent({
    shipmentId: { id: window.shipmentId },
    intentExport: { value: intentExportValue },
    invoices: [
      {
        invoiceId: '',
      },
    ],
  })

  return HttpClient.post(dataSent)
    .then((resp) => resp)
    .catch((error) => {
      console.error(`Error in delete deleteMerchandiseInfo : `, error)
    })
}
export const createMerchandiseItems = (invoiceID, intentExportValue) => {
  let dataSent = saveEvent({
    shipmentId: { id: window.shipmentId },
    intentExport: { value: intentExportValue },

    invoices: [
      {
        invoiceId: invoiceID,
        lineItems: [
          {
            merchandiseId: '',
            invoiceId: invoiceID,
            shipmentId: window.shipmentId,
          },
        ],
      },
    ],
  })

  return HttpClient.post(dataSent)
    .then((resp) => resp)
    .catch((error) => {
      console.error(`Error in delete deleteMerchandiseInfo : `, error)
    })
}

export const saveInvoiceFieldData = (invoiceID, intentExportValue, key) => {
  let currentState = store.getState()
  let completeInvoiceData = currentState.InvoicesReducer.invoices
  let currentInvoiceIndex = completeInvoiceData.findIndex((item) => item.invoiceId == invoiceID)
  let currentInvoiceData = completeInvoiceData[currentInvoiceIndex]
  let value = currentInvoiceData[key]
  let dataSent = saveEvent({
    shipmentId: { id: window.shipmentId },
    intentExport: { value: intentExportValue == 'EX' ? true : false },

    invoices: [
      {
        invoiceId: invoiceID,
        [key]: value,
      },
    ],
  })

  return HttpClient.post(dataSent)
    .then((resp) => resp)
    .catch((error) => {
      showToast('Something went wrong,cannot save the value!')
      console.error(`Error in delete deleteMerchandiseInfo : `, error)
    })
}

export const saveLineData = (invoiceID, merchandiseId, intentExportValue, key) => {
  let currentState = store.getState()
  let completeLineData = { ...currentState.InvoicesReducer.lineItems }
  let lineDataOfInvoice = [...completeLineData[invoiceID]]
  let merchandiseIndex = lineDataOfInvoice.findIndex((item) => item.merchandiseId == merchandiseId)
  let currentLineData = lineDataOfInvoice[merchandiseIndex]
  let value = currentLineData[key]
  let dataSent = saveEvent({
    shipmentId: { id: window.shipmentId },
    intentExport: { value: intentExportValue == 'EX' ? true : false },

    invoices: [
      {
        invoiceId: invoiceID,
        lineItems: [
          {
            merchandiseId: merchandiseId,
            invoiceId: invoiceID,
            [key]: value,
          },
        ],
      },
    ],
  })

  return HttpClient.post(dataSent)
    .then((resp) => resp)
    .catch((error) => {
      showToast('Something went wrong,cannot save the value!')
      console.error(`Error in delete deleteMerchandiseInfo : `, error)
    })
}

export const createMultipleTabs = (invoiceId, merchandiseId, intentExportValue, key) => {
  let dataSent = saveEvent({
    shipmentId: { id: window.shipmentId },
    intentExport: { value: intentExportValue == 'EX' ? true : false },

    invoices: [
      {
        shipmentId: window.shipmentId,
        invoiceId: invoiceId,
        lineItems: [
          {
            merchandiseId: merchandiseId,
            invoiceId: invoiceId,
            [key]: [
              {
                id: '',
                type: 'SELLER',
              },
            ],
          },
        ],
      },
    ],
  })

  return HttpClient.post(dataSent)
    .then((resp) => resp)
    .catch((error) => {
      showToast('Something went wrong,cannot save the value!')
      console.error(`Error in delete deleteMerchandiseInfo : `, error)
    })
}

export const saveMultipleTabsValue = (
  invoiceId,
  merchandiseId,
  intentExportValue,
  key,
  payload
) => {
  let dataSent = saveEvent({
    shipmentId: { id: window.shipmentId },
    intentExport: { value: intentExportValue == 'EX' ? true : false },
    invoices: [
      {
        shipmentId: window.shipmentId,
        invoiceId: invoiceId,
        lineItems: [
          {
            merchandiseId: merchandiseId,
            invoiceId: invoiceId,
            [key]: [
              {
                type: 'SELLER',
                ...payload,
              },
            ],
          },
        ],
      },
    ],
  })

  return HttpClient.post(dataSent)
    .then((resp) => resp)
    .catch((error) => {
      showToast('Something went wrong,cannot save the value!')
      console.error(`Error in delete deleteMerchandiseInfo : `, error)
    })
}

//containers Header Tab
export const createContainerAtHeader = (intentExportValue) => {
  let dataSent = saveEvent({
    shipmentId: { id: window.shipmentId },
    intentExport: { value: intentExportValue == 'EX' ? true : false },
    header: {
      shipmentId: window.shipmentId,
      transportation: {
        containers: [
          {
            containerId: '',
          },
        ],
      },
    },
  })

  return HttpClient.post(dataSent)
    .then((resp) => resp)
    .catch((error) => {
      showToast('Something went wrong,cannot create container!')
      console.error(`Error in container creation : `, error)
    })
}

export const saveContainerValue = (intentExportValue, payload) => {
  let dataSent = saveEvent({
    shipmentId: { id: window.shipmentId },
    intentExport: { value: intentExportValue == 'EX' ? true : false },
    header: {
      shipmentId: window.shipmentId,
      transportation: {
        containers: [
          {
            ...payload,
          },
        ],
      },
    },
  })

  return HttpClient.post(dataSent)
    .then((resp) => resp)
    .catch((error) => {
      showToast('Something went wrong,cannot save the value!')
      console.error(`Error in delete deleteMerchandiseInfo : `, error)
    })
}
